var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sms-content-main" }, [
    _c(
      "div",
      { staticClass: "nav-container" },
      [
        _c(
          "el-menu",
          {
            staticClass: "el-menu-vertical-demo",
            attrs: {
              "default-active": "2",
              "background-color": "#545c64",
              "text-color": "#fff",
              "active-text-color": "#ffd04b"
            }
          },
          [
            _c(
              "el-submenu",
              { attrs: { index: "1" } },
              [
                _c("template", { slot: "title" }, [
                  _c("span", [_vm._v("安检机构")])
                ]),
                _vm._v(" "),
                _c("el-menu-item", { attrs: { index: "1-1" } }, [
                  _vm._v("机构1")
                ]),
                _vm._v(" "),
                _c("el-menu-item", { attrs: { index: "1-2" } }, [
                  _vm._v("机构2")
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("el-menu-item", { attrs: { index: "2" } }, [
              _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v("用户")
              ])
            ]),
            _vm._v(" "),
            _c("el-menu-item", { attrs: { index: "3" } }, [
              _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v("角色")
              ])
            ]),
            _vm._v(" "),
            _c("el-menu-item", { attrs: { index: "4" } }, [
              _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v("权限")
              ])
            ])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content-container" },
      [_c("el-empty", { attrs: { description: "该页面还在努力建设中..." } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e96698e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e96698e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Setting.vue
// module id = null
// module chunks = 